import { Helmet, HelmetProvider } from 'react-helmet-async';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function PageWrapper(props) {
  return _jsxs(HelmetProvider, {
    children: [_jsx(Helmet, {
      defaultTitle: "ApplyBoard",
      titleTemplate: "%s | ApplyBoard",
      children: _jsx("title", {
        children: "Scholarship"
      })
    }), props.children]
  });
}